import { SxProps, Theme } from '@mui/material';

export const stylesBox = {
  boxOne: {
    minHeight: '100vh !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    padding: '24px 0 !important',
  },
  boxThree: {
    overflow: 'hidden !important',
    position: 'relative !important',
    transition: 'transform 0.3s ease-in-out !important',
    '&:hover': {
      transform: 'translateY(-5px) !important',
    },
  },
  boxFour: {
    padding: {
      xs: '24px !important',
      sm: '32px !important',
      md: '40px !important',
      lg: '48px !important',
    },
  },
  boxFive: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    marginBottom: '48px !important',
  },
  boxSix: {
    width: {
      xs: '280px !important',
      sm: '280px !important',
      md: '300px !important',
      lg: '310px !important',
    },
    // mb: {
    //   xs: '24px !important',
    //   sm: '34px !important',
    //   md: '44px !important',
    //   lg: '54px !important',
    // },
    transition: 'transform 0.3s ease !important',
    '&:hover': {
      transform: 'scale(1.05) !important',
    },
  },
  boxSeven: {
    display: 'flex !important',
    alignItems: 'center !important',
    width: '100% !important',
  },
  boxEight: {
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    padding: '10px !important',
    borderRadius: '50% !important',
    marginRight: '16px !important',
    transition: 'transform 0.2s ease !important',
    '&:hover': {
      transform: 'rotate(5deg) !important',
    },
  },
  boxNine: {
    display: 'flex !important',
    mb: 3,
    flexWrap: 'wrap !important',
    flexDirection: {
      xs: 'column !important',
      sm: 'row !important',
    },
    justifyContent: 'center !important',
    gap: '12px !important',
  },
  boxTen: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    gap: '8px !important',
    mt: {
      xs: '24px !important',
      sm: '34px !important',
      md: '44px !important',
      lg: '54px !important',
    },
  },
  boxEleven: {
    height: { xs: '60px !important', sm: '70px !important' },
    transition: 'opacity 0.3s ease !important',
    '&:hover': {
      opacity: '0.9 !important',
    },
  },
} as Record<string, SxProps<Theme>>;

export const stylesBtn = {
  btnOne: {
    color: '#6B7280 !important',
    borderRadius: '12px !important',
    padding: '10px 16px !important',
    textTransform: 'none !important',
    minWidth: 'auto !important',
    fontFamily: 'Roboto-Medium !important',
    boxShadow: 'none !important',
    transition: 'all 0.2s ease !important',
    '&:hover': {
      backgroundColor: 'rgba(107, 114, 128, 0.08) !important',
      transform: 'translateY(-2px) !important',
      color: '#4B5563 !important',
      fontFamily: 'Roboto-Medium !important',
    },
  },
} as Record<string, SxProps<Theme>>;

export const stylesTypo = {
  typoOne: {
    textTransform: 'uppercase !important',
    letterSpacing: '1.5px !important',
    color: '#6B7280 !important',
    marginBottom: '12px !important',
    fontSize: '0.75rem !important',
    fontWeight: '600 !important',
  },
  typoTwo: {
    textTransform: 'uppercase !important',
    letterSpacing: '1.5px !important',
    color: '#6B7280 !important',
    fontSize: '0.75rem !important',
    fontWeight: '600 !important',
  },
} as Record<string, SxProps<Theme>>;

export const stylesOther = {
  dividerOne: {
    marginTop: '32px !important',
    marginBottom: '32px !important',
    opacity: '0.7 !important',
  },
  gridOne: {
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
  },
} as Record<string, SxProps<Theme>>;
